import PlayerCardSkeleton from '@pickleballinc/ui/components/team-leagues-movements/_components/player-card-skeleton';
import { useDrop } from 'react-dnd';

import DraggablePlayer from '@/components/molecules/DraggablePlayer';
import { TeamPlayerInfo } from '@/lib/types';
import { ItemType } from '@/lib/types';

interface AvailablePlayersAreaProps {
	availablePlayers: TeamPlayerInfo[];
	onDrop: (player: TeamPlayerInfo) => void;
	isLoading?: boolean;
}

export default function AvailablePlayersArea({ availablePlayers, onDrop, isLoading = false }: AvailablePlayersAreaProps) {
	const [{ isOver }, drop] = useDrop({
		accept: ItemType.PLAYER,
		drop: (item: TeamPlayerInfo) => onDrop(item),
		collect: (monitor) => ({
			isOver: !!monitor.isOver()
		})
	});

	return drop(
		<div
			className={`flex min-h-[342px] w-[390px] flex-wrap content-start gap-4 rounded-lg border border-gray-300 p-4 ${isOver ? 'bg-gray-100' : ''}`}
		>
			{isLoading ? (
				<>
					<PlayerCardSkeleton />
					<PlayerCardSkeleton />
				</>
			) : availablePlayers.length !== 0 ? (
				availablePlayers.map((player) => <DraggablePlayer key={player.uuid} player={player} />)
			) : (
				<div className="flex size-full items-center justify-center text-darkorange-600">
					<p>There are no players in a team</p>
				</div>
			)}
		</div>
	);
}
